import React from "react";
import { useNavigate, useLocation } from "react-router-dom";
import FooUser from '../../assets/img/user.svg';
import FooWallet from '../../assets/img/wallet.svg';
import FooShop from '../../assets/img/shop.svg';
import FooStar from '../../assets/img/star.svg';
import FooHome from '../../assets/img/home.svg';
import FooDot from '../../assets/img/dot.svg';

const Foother = () => {
  const navigate = useNavigate();
  const location = useLocation(); // مسیر جاری را دریافت می‌کند

  const navItems = [
    { icon: FooUser, route: "/panel/profile", alt: "کاربری", showDot: true },
    { icon: FooWallet, route: "/panel/cards", alt: "کیف پول", showDot: true },
    { icon: FooShop, route: "/panel/shops", alt: "فروشگاه", showDot: false, customClass: "fooshop-spam" }, // shops با کلاس خاص
    { icon: FooStar, route: "/panel/gifts", alt: "ستاره", showDot: true },
    { icon: FooHome, route: "/panel/home", alt: "خانه", showDot: true },
  ];

  return (
    <nav className="bottom-nav">
      {navItems.map((item, index) => (
        <span
          key={index}
          className={`foobtn-1 ${
            item.customClass ? item.customClass : "" // اگر customClass وجود دارد، اضافه شود
          } ${
            location.pathname === item.route && item.showDot ? "active" : ""
          }`}
          onClick={() => navigate(item.route)}
        >
          <img src={item.icon} alt={item.alt} />
          {item.showDot && ( // نقطه فقط برای آیتم‌هایی که showDot=true است نمایش داده می‌شود
            <img
              src={FooDot}
              className={`foodot ${
                location.pathname === item.route ? "foo-active" : "foo-unactive"
              }`}
              alt="dot"
            />
          )}
        </span>
      ))}
    </nav>
  );
};

export default Foother;
